import React, { Fragment } from 'react';
import Item from './Item';

const ExistingFaultDetails = ({ existingFault, details }) => {
  if (!existingFault || 'No' === existingFault) {
    return <Item heading="Existing Fault" content="No" />
  }

  return <Fragment>
    <Item key="existing-fault" heading="Existing Fault?" content="Yes" />
    <Item key="details" heading="Details" content={details} />
  </Fragment>
};

export default ExistingFaultDetails;



// WEBPACK FOOTER //
// ./src/components/Query/QueryShow/ExistingFaultDetails.js